<template>
  <div>
    <DataTable>
      <template #header>
        <span>Skills</span>
        <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      </template>
      <Column header="Skill"/>
      <Column header="Year Of Experience"/>
      <Column header="Comments"/>
      <Column header="Action"/>
    </DataTable>
    <Dialog header="Skills" :visible.sync="displayBasic" @show="setDate"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="name">Skills<span style="color:red">*</span></label>
          <InputText v-model.trim="skills" id="name"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="yearOfExperience">Year Of Experience</label>
          <InputText v-model.trim="yearOfExperience" id="yearOfExperience"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="comments">Comments</label>
          <TextArea rows="5" cols="30" v-model="comments" id="comments"/>
        </div>
      </div>
      <template #footer>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <Button class="p-button-raised"
                    :label="!editing?'Add':'Update'"/>
            <Button class="p-button-raised p-button-info" v-if="!editing"
                    label="Add & New"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import TextArea from 'primevue/textarea'
export default {
  name: 'workExperience',
  data() {
    return {
      displayBasic: false,
      skills: '',
      yearOfExperience: '',
      comments: '',
      editing: false,
      englishDateEnabled: true
    }
  },
  methods: {
    setDate() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#workFrom').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.fromDate = $('#workFrom').val()
        }
      })
      $('#workTo').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.toDate = $('#workTo').val()
        }
      })
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    InputMask,
    DatePicker,
    TextArea
  }
}

</script>



// WEBPACK FOOTER //
// skills.vue?9da88818